export default __webpack_public_path__ + "f0693af5be9bfa5d6c75db1e88c2f1b0.svg";